import { render, staticRenderFns } from "./ToDoToggle.vue?vue&type=template&id=28f84576&scoped=true"
import script from "./ToDoToggle.vue?vue&type=script&lang=js"
export * from "./ToDoToggle.vue?vue&type=script&lang=js"
import style0 from "./ToDoToggle.vue?vue&type=style&index=0&id=28f84576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f84576",
  null
  
)

export default component.exports